import React, { Component } from 'react';


class Hero extends Component {
  render() {
    return (
    <div  
        className="hero-wrapper"
        style={{
            backgroundColor: this.props.backgroundColor,
        }}
    >
        <div 
            class={"hero " + this.props.addClass}
            style={{
                backgroundImage: "url(" + this.props.heroBackground + ")",
                backgroundColor: this.props.innerBackgroundColor,
            }}
        >
            {!this.props.homePage &&
                <div>
                    <p className="company-hero-text">{this.props.companyName}</p>
                    <h2 className={"hero-text"}>{this.props.jobTitle}</h2>
                    <p className="years-active-hero-text">{this.props.yearsActive}</p>
                </div>
            }
        </div>
        
        {!this.props.darkArrow &&
            <div id="sd-container">
                <div className="arrow"></div>
                <div className="arrow"></div>
            </div>
        }

        {this.props.darkArrow &&
            <div id="dark-sd-container">
                <div className="dark-arrow"></div>
                <div className="dark-arrow"></div>
            </div>
        }
        
    </div>
    
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js